import {
  useQuery,
  keepPreviousData,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import qs from "qs";
import { cloneRecipe, getRecipeList } from "../api";
import { useRecipeKeys } from "./useRecipeKeys";
import { useNavigate } from "react-router-dom";
import { errorMessage, successMessage } from "../../../utils";

const tipsandtricksKeys = {
  all: ["tipsandtricks"],
  lists: () => [...tipsandtricksKeys.all, "ingredientlist"],
  tipsandtrickslist: (filters) => [...tipsandtricksKeys.lists(), filters],
  detail: (id) => [...tipsandtricksKeys.tipsandtrickslist(), id],
};

export const useRecipeListQueries = ({
  debouncedText,
  category_id = 0,
  type = "",
  status = -1,
  batch_group = null,
  sorting,
  filterApplied,
  isStoreRecipe,
}) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { recipeKeys } = useRecipeKeys();
  const storeId = filterApplied?.map((item) => item?.id);
  let params = {};
  if (debouncedText) {
    params = { ...params, search: debouncedText };
  }
  if (storeId && !isStoreRecipe) {
    params = { ...params, store: storeId };
  }

  if (sorting?.length > 0) {
    const sortByParams = sorting.reduce(
      (obj, item) =>
        Object.assign(obj, { [item.id]: item.desc ? "desc" : "asc" }),
      {}
    );
    params = {
      ...params,
      sort: sortByParams,
    };
  }

  if (batch_group && !isStoreRecipe) {
    params = { ...params, batch_group: batch_group ? 1 : 0 };
  }
  if (category_id && !debouncedText) {
    params = { ...params, category: category_id };
  }
  if (status > -1 && status !== "" && !isStoreRecipe) {
    params = { ...params, status };
  }
  if (type !== "" && !isStoreRecipe) {
    params = { ...params, type };
  }

  const query = {
    params,
    paramsSerializer: (params) => qs.stringify(params, { encode: true }),
  };

  //list query
  const listQuery = useQuery({
    queryKey: recipeKeys?.recipelist({
      query,
      category_id,
      type,
      status,
      batch_group,
    }),
    queryFn: () =>
      getRecipeList({
        query,
        category_id,
        type,
        status,
        batch_group,
      }),
    placeholderData: keepPreviousData,
    enabled: true,
  });

  //recipe clone query

  const recipeClone = useMutation({
    mutationFn: cloneRecipe,
    onError: (error) => {
      errorMessage(error.response.data);
    },
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({
        queryKey: recipeKeys.list(),
      });
      successMessage("Recipe cloned successfully!");
      navigate(`/recipe/details/${data.id}/?basic-details/${"cloneStatus"}`);
      variables?.onOpenRecipeCloneDialog(false);
    },
  });
  return { listQuery, recipeClone };
};
